import { render } from "./EnIceCream.vue?vue&type=template&id=1f5534cb&scoped=true"
import script from "./EnIceCream.vue?vue&type=script&lang=js"
export * from "./EnIceCream.vue?vue&type=script&lang=js"

import "./EnIceCream.vue?vue&type=style&index=0&id=1f5534cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5534cb"]])

export default __exports__